export default __webpack_public_path__ + "static/media/recruit_android_pic.71828cc9.png";